import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CasinoCard from './components/CasinoCard';
import WagerCalculator from './components/WagerCalculator';
import PromoCodeSection from './components/PromoCodeSection';
import GlossarySection from './components/GlossarySection';
import ReviewsSection from './components/ReviewsSection';
import QuizSection from './components/QuizSection';
import PaymentSystemsSection from './components/PaymentSystemsSection';
import TournamentsSection from './components/TournamentsSection';
import BigWinsSection from './components/BigWinsSection';
import ComparisonTable from './components/ComparisonTable';
import Footer from './components/Footer';
import { casinos } from '../../mocks/casinos';

export default function HomePage() {
  const [onlineCount, setOnlineCount] = useState(12847);

  useEffect(() => {
    const interval = setInterval(() => {
      setOnlineCount(prev => prev + Math.floor(Math.random() * 20) - 10);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up');
        }
      });
    }, observerOptions);

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#0a0a0f] via-[#1a1a1f] to-[#0a0a0f] text-white">
      <Header onlineCount={onlineCount} />
      <Hero />
      
      {/* Main Rating Section */}
      <section className="py-20 px-4 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#1a1a1f] to-transparent opacity-50"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center mb-16 animate-on-scroll opacity-0">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-[#d4af37] via-[#f4d03f] to-[#d4af37] bg-clip-text text-transparent">
              Рейтинг казино с лайв-дилерами 2026: лучшие live-площадки в HD
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-4xl mx-auto leading-relaxed">
              Погрузитесь в атмосферу настоящего казино, не выходя из дома. Наслаждайтесь трансляциями в HD и 4K качестве, 
              общайтесь с профессиональными дилерами и выбирайте из сотен столов с различными лимитами ставок. 
              Мы отобрали лучшие live-казино 2026 года с русскоязычными крупье, быстрыми выплатами и щедрыми бонусами.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {casinos.map((casino, index) => (
              <div key={casino.id} className="animate-on-scroll opacity-0" style={{ animationDelay: `${index * 100}ms` }}>
                <CasinoCard casino={casino} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Russian Dealers Section */}
      <section className="py-20 px-4 bg-gradient-to-r from-[#1a1a1f] via-[#242429] to-[#1a1a1f]">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 animate-on-scroll opacity-0">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
              Лучшие live-казино с русскоязычными дилерами
            </h2>
            <div className="h-1 w-32 bg-gradient-to-r from-[#d4af37] to-transparent"></div>
          </div>
          
          <div className="overflow-x-auto pb-6 hide-scrollbar">
            <div className="flex gap-6 min-w-max">
              {[
                { name: 'Анастасия', flag: '🇷🇺', games: 'Рулетка, Блэкджек', image: 'https://public.readdy.ai/ai/img_res/016f90739700a7fd0af036d8781c4bf1.jpg' },
                { name: 'Дмитрий', flag: '🇷🇺', games: 'Баккара, Покер', image: 'https://readdy.ai/api/search-image?query=professional%20male%20casino%20dealer%20elegant%20suit%20confident%20smile%20studio%20lighting%20dark%20background%20realistic%20portrait&width=300&height=400&seq=dealer-002&orientation=portrait' },
                { name: 'Екатерина', flag: '🇷🇺', games: 'Lightning Roulette', image: 'https://readdy.ai/api/search-image?query=elegant%20female%20casino%20croupier%20professional%20attire%20warm%20smile%20studio%20lighting%20dark%20background%20realistic%20portrait&width=300&height=400&seq=dealer-003&orientation=portrait' },
                { name: 'Александр', flag: '🇷🇺', games: 'Crazy Time, Monopoly', image: 'https://readdy.ai/api/search-image?query=charismatic%20male%20casino%20dealer%20professional%20uniform%20friendly%20expression%20studio%20lighting%20dark%20background%20realistic%20portrait&width=300&height=400&seq=dealer-004&orientation=portrait' },
                { name: 'Мария', flag: '🇷🇺', games: 'Блэкджек VIP', image: 'https://readdy.ai/api/search-image?query=sophisticated%20female%20dealer%20luxury%20casino%20uniform%20elegant%20smile%20studio%20lighting%20dark%20background%20realistic%20portrait&width=300&height=400&seq=dealer-005&orientation=portrait' }
              ].map((dealer, index) => (
                <div key={index} className="bg-[#242429] rounded-3xl p-6 w-72 flex-shrink-0 hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 hover:scale-105 animate-on-scroll opacity-0" style={{ animationDelay: `${index * 100}ms` }}>
                  <div className="relative mb-4">
                    <img src={dealer.image} alt={dealer.name} className="w-32 h-32 rounded-full mx-auto object-cover border-4 border-[#d4af37]" />
                  </div>
                  <h3 className="text-xl font-bold text-center mb-2">{dealer.name} {dealer.flag}</h3>
                  <p className="text-gray-400 text-center mb-4">{dealer.games}</p>
                  <button className="w-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-semibold py-2 px-4 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 whitespace-nowrap">
                    К столу
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Live Games Rules Section */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 animate-on-scroll opacity-0">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Игры с живыми дилерами: правила и стратегии</h2>
            <div className="h-1 w-32 bg-gradient-to-r from-[#d4af37] to-transparent"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { 
                title: 'Блэкджек Live', 
                icon: 'ri-playing-card-line',
                rules: 'Цель - набрать 21 очко или максимально близко к этому числу, не превысив его. Туз = 1 или 11, картинки = 10.',
                strategy: 'Базовая стратегия: удваивайте на 11, берите карту до 17, останавливайтесь на 17+. Избегайте страховки.',
                rtp: '99.5%'
              },
              { 
                title: 'Рулетка Live', 
                icon: 'ri-contrast-drop-line',
                rules: 'Ставьте на числа (0-36), цвета (красное/черное), четность или группы чисел. Выигрыш зависит от типа ставки.',
                strategy: 'Европейская рулетка предпочтительнее (один ноль). Комбинируйте внешние ставки для баланса риска и прибыли.',
                rtp: '97.3%'
              },
              { 
                title: 'Баккара Live', 
                icon: 'ri-vip-crown-line',
                rules: 'Ставьте на Игрока, Банкира или Ничью. Побеждает рука ближе к 9. Третья карта раздается по фиксированным правилам.',
                strategy: 'Ставка на Банкира имеет наименьшее преимущество казино (1.06%). Избегайте ставки на Ничью.',
                rtp: '98.94%'
              },
              { 
                title: 'Покер Live', 
                icon: 'ri-trophy-line',
                rules: 'Различные варианты: Caribbean, Texas Hold\'em, Three Card. Цель - собрать лучшую покерную комбинацию.',
                strategy: 'Изучите таблицу выплат и оптимальную стратегию для конкретного варианта. Управляйте банкроллом.',
                rtp: '96-99%'
              },
              { 
                title: 'Crazy Time', 
                icon: 'ri-gamepad-line',
                rules: 'Игровое шоу с колесом фортуны. 4 бонусных раунда с множителями до x20000. Ставьте на числа или бонусы.',
                strategy: 'Бонусные раунды дают максимальные выигрыши. Комбинируйте ставки на числа и бонусы для баланса.',
                rtp: '96.08%'
              },
              { 
                title: 'Lightning Roulette', 
                icon: 'ri-flashlight-line',
                rules: 'Европейская рулетка с молниями. В каждом раунде 1-5 счастливых чисел получают множители x50-x500.',
                strategy: 'Ставьте на прямые номера для шанса на множители. Комбинируйте с внешними ставками.',
                rtp: '97.3%'
              }
            ].map((game, index) => (
              <div key={index} className="bg-[#242429] rounded-2xl p-6 hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 animate-on-scroll opacity-0" style={{ animationDelay: `${index * 100}ms` }}>
                <div className="w-16 h-16 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-full flex items-center justify-center mb-4">
                  <i className={`${game.icon} text-3xl text-black`}></i>
                </div>
                <h3 className="text-2xl font-bold mb-3">{game.title}</h3>
                <div className="mb-3">
                  <strong className="text-[#d4af37]">Правила:</strong>
                  <p className="text-gray-300 text-sm mt-1">{game.rules}</p>
                </div>
                <div className="mb-3">
                  <strong className="text-[#d4af37]">Стратегия:</strong>
                  <p className="text-gray-300 text-sm mt-1">{game.strategy}</p>
                </div>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-700">
                  <span className="text-gray-400 text-sm">RTP:</span>
                  <span className="text-[#2ecc71] font-bold">{game.rtp}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4K Roulette Section */}
      <section className="py-20 px-4 bg-gradient-to-r from-[#1a1a1f] via-[#242429] to-[#1a1a1f]">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 animate-on-scroll opacity-0">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">ТОП казино с лайв-рулеткой в 4K качестве</h2>
            <div className="h-1 w-32 bg-gradient-to-r from-[#d4af37] to-transparent"></div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {[
              { casino: 'STARDA', game: 'Immersive Roulette 4K', quality: '4K Ultra HD', cameras: '15 камер', features: ['Замедленные повторы', 'Крупные планы', 'Dolby Audio'] },
              { casino: 'Flagman', game: 'Lightning Roulette HD', quality: '4K HDR', cameras: '12 камер', features: ['Множители до x500', 'Динамичное освещение', 'Чат с дилером'] },
              { casino: 'IRWIN', game: 'VIP Roulette Privée', quality: '4K', cameras: '8 камер', features: ['Приватный стол', 'Персональный дилер', 'Высокие лимиты'] },
              { casino: 'Martin', game: 'Speed Roulette Pro', quality: '4K', cameras: '10 камер', features: ['Быстрые раунды', 'Автоматизация', 'Статистика в реальном времени'] }
            ].map((item, index) => (
              <div key={index} className="bg-[#242429] rounded-2xl p-8 hover:shadow-2xl hover:shadow-[#d4af37]/20 transition-all duration-300 animate-on-scroll opacity-0" style={{ animationDelay: `${index * 100}ms` }}>
                <div className="flex items-start justify-between mb-4">
                  <div>
                    <h3 className="text-2xl font-bold mb-2">{item.casino}</h3>
                    <p className="text-[#d4af37] text-lg">{item.game}</p>
                  </div>
                  <span className="bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black px-4 py-2 rounded-full text-sm font-bold whitespace-nowrap">
                    {item.quality}
                  </span>
                </div>
                <div className="flex items-center gap-2 mb-4 text-gray-400">
                  <i className="ri-camera-line text-[#d4af37]"></i>
                  <span>{item.cameras}</span>
                </div>
                <ul className="space-y-2 mb-6">
                  {item.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-gray-300">
                      <i className="ri-check-line text-[#2ecc71]"></i>
                      {feature}
                    </li>
                  ))}
                </ul>
                <button className="w-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-semibold py-3 px-6 rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 whitespace-nowrap">
                  Играть в 4K
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <WagerCalculator />
      <PromoCodeSection />
      <ComparisonTable />
      <PaymentSystemsSection />
      <TournamentsSection />
      <BigWinsSection />
      <ReviewsSection />
      <GlossarySection />
      <QuizSection />
      <Footer />
    </div>
  );
}